<template>
  <div>
    <div v-if="!readOnly" class="ml-2 mr-2 mb-2 mt-2">
      <label>{{ $t('operacoes') }} </label>
      <b-form-select
        class="input-pentagro"
        v-model="operationSelected"
        :options="operations"
      ></b-form-select>
    </div>
    <b-form v-if="operationSelected" class="b-layout">
      <div>
        <div class="inp">
          <label>{{ $t('capacidade-m') }} </label>
          <input v-model="Capacidade.value" min="0" step="0.01" type="number" />
        </div>
        <div class="inp">
          <label>{{ $t('tempo-de-residencia-necessario-h') }} </label>
          <input
            v-model="TempoNecessario.value"
            min="0"
            max="100"
            step="0.1"
            type="number"
          />
        </div>
        <div class="inp">
          <label>{{ $t('capacidade-necessaria-m') }} </label>
          <label>{{ CapacidadeNecessaria.value | ParseNumber }}</label>
        </div>
        <div class="inp">
          <label>{{ $t('tempo-de-residencia-h') }} </label>
          <label>{{ TempoResidencia.value | ParseNumber }}</label>
        </div>
        <div class="inp">
          <label>{{ $t('taxa-de-utilizacao') }} </label>
          <label>{{ TxUtilizacao.value | ParseNumber }}</label>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { ParseToNumber } from "../../utils/tools";
import { FiltersMixin } from "../../../mixins/filtersMixin";


export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly:{
      type: Boolean,
      default: false,
    }
  },

  mixins: [FiltersMixin],

  data() {
    return {
      attrList: [
        "Capacidade",
        "TempoNecessario",
        "CapacidadeNecessaria",
        "TempoResidencia",
        "TxUtilizacao",
      ],
      Capacidade: {},
      TempoNecessario: {},
      CapacidadeNecessaria: null,
      TempoResidencia: null,
      TxUtilizacao: null,
      operations: [{ value: null, text:this.$t('selecione-uma-operacao') }],
      operationSelected: null,
      operationAttributeList: [],
      firstLoad: false,
    };
  },

  watch: {
    operationSelected(value) {
      if (this.firstLoad || !value) {
        this.firstLoad = false;
        return;
      }

      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));

      this.attrList.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );

        this[attrName].value = ParseToNumber(this[attrName].value);
      });
      this.updateNode();
    },

    "Capacidade.value"() {
      this.updateNode();
    },

    "TempoNecessario.value"() {
      this.updateNode();
    },
  },

  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        this.firstLoad = true;
        this.operationSelected = this.node.data[0].index;
        this.loadNotInput();
      }

      this.node.data.forEach((p) => {
        let prop = p.clone();
        prop.value = ParseToNumber(prop.value);
        this[p.caption] = prop;
      });
    },

    updateNode() {
      this.node.attrs = [this.Capacidade.clone(), this.TempoNecessario.clone()];
    },

    loadNotInput() {
      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));
      let attrNotInput = this.attrList.slice(2);

      attrNotInput.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );

        if (this[attrName])
          this[attrName].value = ParseToNumber(this[attrName].value);
      });
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) => o.match(/FL/));
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },
  },

  mounted() {
    this.loadOperation();
    this.loadNode();
  },
};
</script>

<style scoped>
form {
  padding: 10px;
  color: #0009;
}

.b-layout {
  display: flex;
  justify-content: space-between;
}

input {
  margin-left: 5px;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>